var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { createContext } from "react";
export var ImportContext = createContext({});
/**
 * Composant pour l'import des enregistrements
 * @param is
 * @param useDefaultPath
 * @param rest
 * @returns
 */
var ImportWizard = function (_a) {
    //const { t } = useTranslation(["Import"]);
    var is = _a.is, _b = _a.useDefaultPath, useDefaultPath = _b === void 0 ? true : _b, settings = __rest(_a, ["is", "useDefaultPath"]);
    return (_jsx(_Fragment, { children: _jsx("div", { children: React.createElement(useDefaultPath ? require("./".concat(is, ".tsx")).default : is, __assign({}, settings)) }) }));
};
export default ImportWizard;
